import moment from 'moment';

const getFileName = (callInfo) => {
  const dateTime = moment(callInfo.createTime);
  const date = dateTime.format('DD.MM.YYYY') || '';
  const time = dateTime.format('HH:mm') || '';
  const direction = callInfo.direction || '';
  const phoneNum = callInfo.callerId || '';
  const ext = 'wav';

  const result = `${date} ${time} ${direction} ${phoneNum}`;

  return `${result.trim()}.${ext}`;
};

export const createDownloadLink = (url, callInfo) => {
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', getFileName(callInfo));

  document.body.appendChild(link);
  link.click();

  return link;
};
